import React, { Component } from 'react'
import HitMesh3D from './hitMesh3D'
import * as THREE from 'three'

export default function HitPlane3D(props) {
    return <HitMesh3D geometry={THREE.PlaneBufferGeometry} {...props} />
}
